import type { ReactNode } from 'react';
import type { SxProps, Theme } from '@mui/material/styles';

import { alpha } from '@mui/material/styles';
import Chip from '@mui/material/Chip';

export type StatusChipColor = 'success' | 'warning' | 'error' | 'info' | 'default';

export interface StatusChipProps {
  label: string;
  color: StatusChipColor;
  size?: 'small' | 'medium';
  icon?: ReactNode;
  sx?: SxProps<Theme>;
}

export function StatusChip({ label, color, size = 'small', icon, sx }: StatusChipProps) {
  const baseSx: SxProps<Theme> = (theme) => {
    const isDefault = color === 'default';
    const bg = isDefault
      ? alpha(theme.palette.grey[500], 0.16)
      : alpha(theme.palette[color].main, 0.16);
    const fg = isDefault ? theme.palette.grey[400] : theme.palette[color].light;

    return {
      height: size === 'small' ? 22 : 28,
      fontSize: size === 'small' ? 11 : 13,
      fontWeight: 600,
      bgcolor: bg,
      color: fg,
      borderRadius: '50px',
      '& .MuiChip-label': { px: icon ? 1 : size === 'small' ? 1.25 : 1.5 },
      ...(icon && {
        '& .MuiChip-icon': { ml: 0.75, color: `${fg} !important` },
      }),
    };
  };

  return <Chip label={label} size={size} icon={icon as React.ReactElement | undefined} sx={[baseSx, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]} />;
}
